import { useEffect } from "react";

const ANCHOR_SCROLL_OFFSET = 80;

const useScrollToAnchor = (anchorId?: string | null) => {
  useEffect(() => {
    if (!anchorId || window.location.hash !== `#${anchorId}`) {
      return undefined;
    }

    let hasScrolled = false;
    let observer: MutationObserver | undefined;

    const scrollToAnchor = () => {
      if (hasScrolled) {
        return;
      }

      const element = document.getElementById(anchorId);
      if (!element) {
        return;
      }

      hasScrolled = true;
      observer?.disconnect();
      const distanceFromTop = element.getBoundingClientRect().top;

      window.scrollTo({
        top: window.scrollY + distanceFromTop - ANCHOR_SCROLL_OFFSET,
        behavior: "smooth"
      });
    };

    scrollToAnchor();

    if (!hasScrolled) {
      observer = new MutationObserver(scrollToAnchor);
      observer.observe(document.body, { childList: true, subtree: true });
    }

    return () => observer?.disconnect();
  }, [anchorId]);
};

export default useScrollToAnchor;
